import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpErrorResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { CommonModelResponse, RepresentativeDetails } from '../../models';
import { environment } from '../../../environments/environment';

@Injectable()
export class CommonService {
    constructor(private http: HttpClient) {
    }

    /* Get Crm Representative Details */

    public GetCRMRepresentativeDetails(): Observable<CommonModelResponse<RepresentativeDetails>> 
    {
        return this.http.get<CommonModelResponse<RepresentativeDetails>>(environment.apiUrl + "api/GetRepresentativeDetails",
            {
                headers: new HttpHeaders().set('Content-Type', 'application/json')
                    .set('Authorization', 'Bearer ' + sessionStorage.getItem('SToken'))
            }
        ).pipe(data => data);
    }


}
